document.addEventListener("click", function (e) {
  const btn = e.target.closest(".bm-coupon__copy");
  if (!btn) return;

  const couponEl = btn.closest(".bm-coupon");
  if (!couponEl) return;

  let code = couponEl.dataset.couponCode || "";
  if (!code) {
    const strongEl = couponEl.querySelector("strong");
    if (strongEl) code = strongEl.textContent.trim();
  }
  if (!code) return;

  function showCopiedUI() {
    const original = btn.innerHTML;
    btn.innerHTML =
      '<svg class="bm-copy-icon" viewBox="0 0 24 24"><path d="M5 13l4 4L19 7" stroke="#2A9D4A" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg>' +
      '<span class="bm-copy-text">Copied</span>';
    setTimeout(function () {
      btn.innerHTML = original;
    }, 1300);
  }

  function fallbackCopy() {
    var ta = document.createElement("textarea");
    ta.value = code;
    ta.style.position = "fixed";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    try { document.execCommand("copy"); } catch (err) {}
    document.body.removeChild(ta);
    showCopiedUI();
  }

  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(code).then(showCopiedUI).catch(fallbackCopy);
  } else {
    fallbackCopy();
  }
});
